export default __webpack_public_path__ + "ff38abb1412fb347f9099787da9c4d38.png";